import { FINPSP_BANK_LABELS } from '../../../constants/finpsp';
import { Box, Stack, Typography } from '@mui/material';
import { FINPSP_DEPOSIT_CHANNELS } from '../../../constants/finpsp';
import { getFinpspDepositType, getFinpspInstructionStatusKey } from '../../../helpers/payment/finpsp';
import useLocalization from '../../../hooks/useLocalization';
import { finpspPaymentProviders } from '../../../config/payment/finpsp';
import type { FinpspPayment } from '../../../types/finpsp';

const styles = {
  root: {
    gap: 1.5,
    alignItems: 'center',
  },
  icon: {
    fontSize: 44,
    flexShrink: 0,
  },
  title: {
    color: 'neutral.25',
    letterSpacing: 0,
    mb: 0.5,
  },
};

const FinpspPaymentStatus = ({ payment }: { payment: FinpspPayment }) => {
  const { t } = useLocalization();
  const ProviderIcon = finpspPaymentProviders.find(({ value }) => value === payment.bank_type)?.icon;
  const channel = FINPSP_DEPOSIT_CHANNELS[getFinpspDepositType(payment)];
  const statusKey = getFinpspInstructionStatusKey(payment);
  const showStatus = statusKey !== 'finpspAssigningNumber';

  return (
    <Stack direction='row' sx={styles.root}>
      {ProviderIcon && <ProviderIcon sx={styles.icon} />}
      <Box>
        <Typography component='h2' variant='h3' sx={styles.title}>
          {FINPSP_BANK_LABELS[payment.bank_type]} · {t(channel.actionKey ?? 'deposit')}
        </Typography>
        {showStatus && (
          <Typography variant='body2' color='text.secondary' role='status'>
            {t(statusKey)}
          </Typography>
        )}
      </Box>
    </Stack>
  );
};

export default FinpspPaymentStatus;
